import { render, staticRenderFns } from "./answers.vue?vue&type=template&id=2ac0eff8&scoped=true&"
import script from "./answers.vue?vue&type=script&lang=js&"
export * from "./answers.vue?vue&type=script&lang=js&"
import style0 from "./answers.vue?vue&type=style&index=0&id=2ac0eff8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac0eff8",
  null
  
)

export default component.exports